import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { PriceDirective } from './price.directive';
export var PriceComponentNgModule = module(baseModuleId + ".price", [])
    .directive('price', PriceDirective);
